<template>
	<div class="user_wrap">
		<div class="header_box" v-if="show_page">
			<div class="red_top_bg">
				<div class="big_tit">{{ $t('home.my') }}</div>
				<div class="language_user" @click="$router.push('/language')">
					<img :src="language_logo">
					<div>{{ country_loc }}</div>
				</div>
			</div>

			<div class="user_detail">
				<div class="user_header">
					<img class="headers" :src="data.user_icon" alt="">
				</div>
				<!-- 邀请码 -->
				<div class="user_detail_right">
					<div class="user_name">
						<div class="user_all">
							<p class="user_nickname">{{ data.username }}</p>
						</div>
					</div>
					<div class="invite_code">
						<!-- <p class="invite_tips">{{ $t('user.invite_code') }}</p> -->
						<div class="flex_center copy" @click="copyData">
							<p>{{ $t('user.invite_code') }}:{{ data.invite_code }}</p>
							<img class="copy_img" src="../img/user/copy.png">
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- usdt  充值提现 -->
		<div class="user_func_box" v-if="show_page">
			<div class="blanceBox" v-if="home_show==1">
				<!-- 头部 -->
				<div class="blance_box">
					<div class="left">
						<div class="top">
							<div class="ico"><img class="usdt_img" src="../img/user/usdt.png"></div>
							<div class="name">USDT</div>
						</div>
						<div class="blance_num">{{ fundBalanceUsd }}</div>
					</div>
					<div class="left">
						<div class="top">
							<div class="ico"><img class="usdt_img" src="../img/user/trx.png"></div>
							<div class="name">TRX</div>
						</div>
						<div class="blance_num">{{ fundBalanceTrx }}</div>
					</div>
				</div>
				<!-- 中间 -->

				<!-- 底部 充值 体现按钮 -->
				<div class="bottom">
					<div class="chongzhi" @click="$router.push('/recharge')">{{ $t('user.recharge') }}</div>
					<div class="shu"></div>
					<div class="tixian" @click="withdraw(1)">{{ $t('user.withdraw') }}</div>
				</div>
			</div>

			<div class="block_div userBox">
				<div class="title">{{ $t('user.myBlance') }}</div>
				<div class="flex_center user_yw" >
					<div @click="$router.push('/invest/record')" v-if="home_show == 1">
						<img src="../img/user/order.png" alt="" />
						<p>{{ $t('user.inviteRecord') }}</p>
					</div>
					<div @click="$router.push('/funding/record')" v-if="home_show == 1">
						<img src="../img/user/details.png" alt="" />
						<p>{{ $t('user.fundingDetails') }}</p>
					</div>
					<div @click="$router.push('/integral/record')" >
						<img src="../img/user/recharge.png" alt="" />
						<p>{{ $t('积分明细') }}</p>
					</div>
				</div>
			</div>

			<div class="block_div list" v-if="home_show==1">
				<!-- <van-cell is-link @click="$router.push('/goods')"> -->
				<!-- <van-cell is-link @click="signin()">
				<template #title>
					<img src="../img/user/signin2.png" alt="">
					<span class="custom-title">{{ $t('user.signin') }}</span>
				</template>
			</van-cell> -->
				<van-cell is-link v-for="(item, index) in menus1" :key="index" @click="$router.push(item.url)">
					<template #title>
						<img :src="require('../img/' + item.logo)" alt="">
						<span class="custom-title">{{ item.title }}</span>
					</template>
				</van-cell>
			</div>
			<div class="block_div list" v-if="home_show==0">
				<van-cell is-link v-for="(item, index) in menus3" :key="index" @click="$router.push(item.url)">
					<template #title>
						<img :src="require('../img/' + item.logo)" alt="">
						<span class="custom-title">{{ item.title }}</span>
					</template>
				</van-cell>
			</div>
			<div class="block_div list">
				<van-cell is-link v-for="(item, index) in menus2" :key="index" @click="$router.push(item.url)">
					<template #title>
						<img :src="require('../img/' + item.logo)" alt="">
						<span class="custom-title">{{ item.title }}</span>
					</template>
				</van-cell>
			</div>
			<!-- <button class="basic_btn logout_btn" @click="logout">{{ $t('user.signOut') }}</button> -->
			<div class="func_box">

				<div class="func_btn" @click="logout">{{ $t('user.signOut') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import qs from 'qs';
import Fetch from '../../utils/fetch';
import Api from "../../interface/index";
import Clipboard from "v-clipboard";
import {
	Icon,
	Cell,
	CellGroup
} from "vant";

Vue.use(Cell).use(CellGroup).use(Icon).use(Clipboard);

export default {
	name: "user",
	components: {},
	data() {
		return {
			country_loc: localStorage.getItem("country_loc") ? localStorage.getItem("country_loc") : 'English',
			language_logo: localStorage.getItem('language_logo'),
			logo: localStorage.getItem("logo2"),
			currency: '',
			isShowUSDTORTRX: true,
			menus1: [
				// 	{
				// 	"title": this.$t('savings.savings'),
				// 	"value": '',
				// 	"logo": "user/savings.png",
				// 	"url": "/savings"
				// }, {
				// 	"title": this.$t('积分明细'),
				// 	"value": '',
				// 	"logo": "user/details.png",
				// 	"url": "integral/record"
				// },
				{
					"title": this.$t('user.vip'),
					"value": '',
					"logo": "user/vip.png",
					"url": "/vip"
				},
				{
					"title": this.$t('user.rewards'),
					"value": '',
					"logo": "user/rewards.png",
					"url": "/rewards"
				},
				{
					"title": this.$t('goods.exchangeRecord'),
					"value": '',
					"logo": "user/order.png",
					"url": "/goods/record"
				},
				{
					"title": this.$t('user.rechargeRecord'),
					"value": '',
					"logo": "user/recharge.png",
					"url": "/recharge/record"
				},
				{
					"title": this.$t('user.withdrawRecord'),
					"value": '',
					"logo": "user/cash.png",
					"url": "/withdraw/record"
				},
				{
					"title": this.$t('user.withdrawAccount'),
					"value": '',
					"logo": "user/moneybag.png",
					"url": "/wallet"
				},
				// {
				// 	"title": this.$t('user.certificationCenter'),
				// 	"value": '',
				// 	"logo": "user/auth1.png",
				// 	"url": "/auth"
				// },
				{
					"title": this.$t('invite.invite'),
					"logo": "user/invite.png",
					"url": "/invite"
				},

			],
			menus3: [
				
				
				{
					"title": this.$t('user.rewards'),
					"value": '',
					"logo": "user/rewards.png",
					"url": "/rewards"
				},
				{
					"title": this.$t('goods.exchangeRecord'),
					"value": '',
					"logo": "user/order.png",
					"url": "/goods/record"
				},
			
				{
					"title": this.$t('invite.invite'),
					"logo": "user/invite.png",
					"url": "/invite"
				},

			],
			menus2: [
				// {
				// 	"title": this.$t('user.userAgreement'),
				// 	"logo": "user/agreement.png",
				// 	"url": "/language"
				// },
				{
					"title": this.$t('user.userInfo'),
					"value": '',
					"logo": "user/info.png",
					"url": "/info"
				}
				,
				// {
				// 	"title": this.$t('user.languagePreference'),
				// 	"value": '',
				// 	"logo": "user/language.png",
				// 	"url": "/language"
				// },
				{
					"title": this.$t('user.faq'),
					"value": '',
					"logo": "user/question.png",
					"url": "/questions"
				}
			],
			data: {},
			fundBalance: 0.00,
			fundBalanceUsd: 0.00,
			fundBalanceTrx: 0.00,
			savings: 0.00,
			eye: 1,
			signinStatue: false,
			tax: 1,
			home_show: 0,
			show_page:false
		};
	},
	created() {
		if (window.plus) {
			plus.navigator.setStatusBarBackground('#051C3F');
			plus.navigator.setStatusBarStyle('light');
		}
		this.$parent.footer('user');
	},
	mounted() {
		this.start();
	},
	methods: {
		copyData() {
			//如果需要回调：
			this.$copyText(this.data.invite_code).then(e => {
				this.$toast(this.$t('recharge.copySuccess'));

			}, function (e) {

			})
		},
		copy() {
			this.$toast(this.$t('recharge.copySuccess'));
		},
		showMsg() {
			this.$dialog.alert({
				closeOnClickOverlay: true,
				showConfirmButton: false,
				message: "<p style='text-align: left'>" +
					this.$t('user.fundingTips') +
					"</p>",
			}).catch(() => {
				// on close
			});
		},
		withdraw(type) {
			if (this.tax == 1) {
				this.$toast(this.$t('user.taxTips'));
				return false;
			}
			if (type == 1) {
				this.$router.push('/withdraw')
			} else {
				this.$router.push('/withdraw?type=trx')
			}

		},
		signin() {
			var that = this;
			if (this.signinStatue) {
				this.$toast(this.$t('user.signined'));
				setTimeout(function () {
					that.$router.push('/goods');
				}, 3000);
				return;
			}
			this.signinStatue = true;

			Fetch('/user/signin').then((r) => {
				this.$toast(this.$t('login.txt12') + r.data.point + this.$t('login.txt13'));
				setTimeout(function () {
					that.$router.push('/goods');
				}, 3000);
			});
		},
		start() {
			var isapp = 0;
			if (window.plus) {
				isapp = 1;
			}
			if (localStorage.getItem('token')) {
				Fetch('/user/info', {
					isapp: isapp
				}).then((r) => {
					this.data = r.data;
					this.fundBalance = r.data.fundBalance;
					this.fundBalanceUsd = r.data.fundBalanceUsd;
					this.fundBalanceTrx = r.data.fundBalanceTrx
					this.menus1[0]['value'] = r.data.vip_name;
					this.currency = r.data.currency;
					this.signinStatue = r.data.signin;
					this.tax = r.data.tax;
				});
			} else {
				this.$router.replace('/login');
			}

			Fetch('/index/int').then((r) => {
				this.home_show = r.data.home_show;
				this.show_page=true;
			});

		},
		logout() {
			localStorage.removeItem('token');
			this.$router.replace("/");
		},
	}
};
</script>

<style lang="less" scoped>
.language_user {
	position: absolute;
	top: 16px;
	right: 3%;
	height: 36px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	color: white;

	img {
		height: 100%;
	}
}

.blance_box {
	display: flex;
	align-items: center;
	justify-content: space-around;

	.top {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;

		.ico {
			.usdt_img {
				width: 40px;
			}

		}

		.name {
			font-weight: 600;
			font-size: 16px;
			line-height: 22px;
			color: #999999;
			margin-left: 6px;
		}
	}

	.blance_num {
		font-weight: 600;
		font-size: 16px;
		line-height: 22px;
		color: #999999;
		margin-left: 6px;
	}

}

.user_wrap {
	margin-bottom: 60px;
}

.func_box {
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 750px;
	width: 100%;
	margin-top: 20px;

	.func_btn {
		width: 80%;
		background-color: #326CF6;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 50px;
		font-size: 16px;
		width: 80%;
		background-size: 100% 100%;
		border-radius: 16px;
		color: #FFFFFF;
		background: #0F6EFF;
		text-align: center;
	}

}

.user_func_box {
	margin-top: 160px;
	z-index: 1000;
}

.blanceBox {
	background: #FFFFFF;
	box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.03);
	border-radius: 8px;
	margin: 0 12px;
	padding: 16px;

	// width: 100%;

	.top {
		display: flex;
		justify-content: space-between;

		.left {
			display: flex;
			justify-content: center;
			align-items: center;

			.usdt_img {
				width: 40px;
			}

			.name {
				font-weight: 600;
				font-size: 16px;
				line-height: 22px;
				color: #999999;
				margin-left: 6px;
			}
		}

		.right {
			text-align: center;
			justify-content: center;
			align-items: center;

			.changetitle {
				font-size: 12px;
				color: #999999;
			}

			.change_img {
				text-align: center;
				width: 21px;
				height: 17px;
			}
		}

	}

	.center {
		margin-top: 4px;

		.blancenum {
			font-weight: 600;
			font-size: 20px;
			line-height: 28px;
			color: #000000;

			span {
				font-weight: 600;
				font-size: 13px;
				line-height: 18px;
				color: #999999;
			}
		}

		.blancenum2 {
			font-weight: 600;
			font-size: 13px;
			line-height: 18px;

			color: #999999;
		}

		.lines {
			width: 100%;
			border: 1px solid #F2F2F2;
			margin-top: 20px;
		}
	}

	.bottom {
		margin-top: 16px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		text-align: center;

		.chongzhi {
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			line-height: 22px;
			color: white;
			height: 38px;

			width: 100%;
			text-align: center;
			background: #326CF6;
			margin: 0 10px;
			border-radius: 8px;
			line-height: 38px;
		}

		.tixian {
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			height: 38px;
			width: 100%;
			color: white;
			background: #FF5722;
			margin: 0 10px;
			border-radius: 8px;
			line-height: 38px;
		}

		.shu {
			height: 18px;
			width: 1px;
			background: #F3F3F3;
		}
	}
}

.header_box {
	background-color: #326CF6;
	position: fixed;
	width: 100%;
	top: 0;
	z-index: 1;
	border-radius: 0 16px 16px 16px;
	max-width: 750px;

	.red_top_bg {
		background-color: #326CF6;
		box-shadow: unset;
		height: 50px;

		.big_tit {
			left: 50%;
			top: 10px;
			transform: translateX(-50%);
			color: #FFFFFF;
		}

		.msg {
			position: absolute;
			top: 12px;
			right: 15px;

			img {
				width: 22px;
				height: 22px;
			}
		}
	}

	.user_detail {
		width: 100%;
		padding: 16px;
		top: 34px;
		display: flex;
		align-items: center;

		.user_header {
			overflow: hidden;
			border-radius: 50%;
			border: 3px solid rgba(255, 255, 255, 0.3);
			display: flex;
			justify-content: center;
			align-items: center;

			.headers {
				width: 80px;
				height: 65px;
			}
		}

		.user_detail_right {
			width: 100%;
			height: 100%;
			margin-left: 16px;
			background: #326CF6;

			.user_name {
				margin-left: 3px;
				margin-top: 3px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: flex-start;

				.user_all {
					// display: flex;
					// justify-content: flex-start;
					// align-items: center;

					.user_nickname {
						line-height: 21px;
						font-size: 22px;
						font-weight: 600;
						color: #FFFFFF;
						margin-top: 2px;
					}

					img {
						width: 22px;
						border-radius: 50%;
						margin-right: 3px;
					}

					.auth {
						justify-content: unset;
						margin-top: 3px;
					}

					.active {
						border: 2px solid #FFEB3B;
					}
				}
			}

			.invite_code {
				text-align: center;
				display: flex;
				margin-top: 12px;

				p {
					color: #A3BEFF;
					font-size: 16px;
				}

				.invite_tips {
					color: #A3BEFF;
					margin-bottom: 10px;
					font-size: 16px;
				}

				.copy {
					justify-content: space-between;
					font-size: 16px;

					.copy_img {
						width: 22px;
						height: 22px;
						margin-left: 12px;
					}
				}

			}
		}


	}
}





.userBox {
	margin-top: 16px;

	.title {
		font-weight: 600;
		color: black;
		font-size: 16px;
		padding: 16px;
	}

	.user_yw {
		position: relative;
		padding: 15px 0;
		margin-bottom: 10px;
		justify-content: space-between;
		text-align: center;

		div {
			width: 33.33%;
		}

		p {
			margin-top: 8px;
		}

		img {
			width: 30px;
			height: 30px;
		}
	}

}




.list {
	margin-top: 10px;

	img {
		vertical-align: middle;
		height: 24px;
		width: 22px;
		margin-right: 10px;
	}

	span {
		font-size: 14px;
	}
}

.logout_btn {
	margin: 30px 24px;
	background: #326CF6;
	border-radius: 8px;
	height: 44px;
	font-weight: 400;
	font-size: 16px;
	line-height: 44px;
	text-align: center;
}

/deep/ .van-cell {
	background: unset;
}
</style>
